import React from 'react';

import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import { AMPWaveBack, AMPWaveMiddle, AMPWaveFront } from '../../AMPWave';
import OutboundLink from '../../OutboundLink';
import Icon from '../../../shared/Icon';
import PlatformBadge from './PlatformBadge';
import styles from '../styles.sass';
import AMPTrackedLink from '../../AMPTrackedLink';

const IMG_PREFIX = 'https://d12xoj7p9moygp.cloudfront.net/images/';

const HeaderSection = () => (
  <div className={styles.homeHeader}>
    <Row bsClass={`${styles.aligned} ${styles.headerCopy} row`}>
      <h1>The best way to make your podcast.</h1>
      <div>
        <p>
          Create and host unlimited episodes, distribute your show everywhere,
          and make money. All in one place, all for free.
        </p>
        <AMPTrackedLink
          eventCategory="Onboarding"
          eventLabel="Start"
          to="/signup"
        >
          <button className={`cyanButton ${styles.linkButton}`}>
            Get started now
          </button>
        </AMPTrackedLink>
        <div className={styles.platformBadgeSectionContainer}>
          <div className={styles.platformBadgeSection}>
            <OutboundLink
              to="https://itunes.apple.com/app/apple-store/id1056182234?pt=118017867&ct=WebsiteTracking&mt=8"
              newWindow
              className={styles.platformBadgeLink}
            >
              <PlatformBadge
                renderIcon={() => (
                  <div className={styles.appleLogoWrapper}>
                    <Icon type="apple_logo" fillColor="#ffffff" />
                  </div>
                )}
                label="App Store"
                contentClass={styles.appleStoreBadgeContent}
              />
            </OutboundLink>
            <OutboundLink
              to="https://play.google.com/store/apps/details?id=fm.anchor.android&referrer=utm_source%3DAnchor%2520Home%26utm_medium%3Dcpc%26utm_campaign%3DAnchor%2520Home%26anid%3Dadmob"
              newWindow
              className={styles.platformBadgeLink}
            >
              <PlatformBadge
                renderIcon={() => (
                  <Icon type="google_play_logo" fillColor="#ffffff" />
                )}
                label="Google Play"
                contentClass={styles.googlePlayStoreBadgeContent}
              />
            </OutboundLink>
          </div>
        </div>
      </div>
    </Row>
    {/* Positioned here to avoid using z-index on waves */}
    <AMPWaveBack />
    <AMPWaveMiddle />
    <Row bsClass={`${styles.aligned} row`}>
      <Col className={`col-xs-12 ${styles.homeVideo} amp-ex-home-video-1`}>
        <div className={styles.homeVideoFrame}>
          <amp-iframe
            width="277"
            height="156"
            sandbox="allow-scripts allow-same-origin allow-presentation"
            layout="responsive"
            frameborder="0"
            src="https://www.youtube.com/embed/videoseries?list=PLJ_1GxcJR2S_7SbiQo3tdfVvJR6tLnS8d&amp;cc_load_policy=1&amp;loop=1&amp;showinfo=0&amp;autoplay=1&amp;mute=1&amp;rel=0&amp;ytp-pause-overlay=0 "
            scrolling="no"
            allow="autoplay; fullscreen"
          >
            <amp-img
              layout="fill"
              src={`${IMG_PREFIX}home-video-placeholder-2.jpg`}
              placeholder
            />
          </amp-iframe>
        </div>
      </Col>
    </Row>
    <AMPWaveFront />
  </div>
);

export default HeaderSection;
